import React from 'react';
import { Grid, Header, Segment } from 'semantic-ui-react';

import UserDistributionsBarChart from '../Charts/UserDistributionsBarChart';
import UserDistributionsMap from '../Charts/UserDistributionsMap';
import { CustomContainer, RequiresLogin } from '.'; // eslint-disable-line import/no-cycle

export default (props) => {
  const { authed, data, isFetching, isMobile } = props;
  const hasData = (Array.isArray(data) && data.length > 0);

  return (
    <CustomContainer>
      <Header as={isMobile ? 'h3' : 'h2'} attached="top">
        熱點
      </Header>
      <Segment
        loading={isFetching}
        attached
      >
        <RequiresLogin dimmed={!authed}>
          {
            hasData ? (
              <Grid
                centered
                stackable
                columns="equal"
              >
                <Grid.Column>
                  <UserDistributionsMap
                    data={data}
                    domain={[0, 100]}
                    isMobile={isMobile}
                  />
                </Grid.Column>
                <Grid.Column>
                  <UserDistributionsBarChart
                    data={data}
                    indexBy="city"
                    isMobile={isMobile}
                    keys={['count']}
                  />
                </Grid.Column>
              </Grid>
            ) : (
              <p>無資料 (._.)</p>
            )
          }
        </RequiresLogin>
      </Segment>
    </CustomContainer>
  );
};
